/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_FooterInputs */



/**
* | output |
* | --- |
* | "On Free, Starter and Team, oneAI Standard is billed at €0 in the oneAI app. Private models are always billed at €0." |
*
* @param {Model_Pricing_FooterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_footer = /** @type {((inputs?: Model_Pricing_FooterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_FooterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei Free, Starter und Team wird oneAI Standard in der oneAI-App mit €0 abgerechnet. Private Modelle werden immer mit €0 abgerechnet.")
	return /** @type {LocalizedString} */ ("On Free, Starter and Team, oneAI Standard is billed at €0 in the oneAI app. Private models are always billed at €0.")
});